import React from 'react';
import { useNavigate } from 'react-router-dom';

function LogoutButton({ className = '' }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('tokenType');
    navigate('/'); // or navigate('/login')
  };

  return (
    <button onClick={handleLogout} className={className}>
      Logout
    </button>
  );
}

export default LogoutButton;
